import { render, staticRenderFns } from "./KakaoHistory.vue?vue&type=template&id=db45aeda&"
import script from "./KakaoHistory.vue?vue&type=script&lang=js&"
export * from "./KakaoHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports